// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

// ** Axios Imports
import api from "@src/api/config"
import { showModalSuccess } from "../../../../redux/modalTypeSuccess"
import {
  getBusinessNameResource,
  getOwnerPayload,
  normalizeTaxDataCollection
} from "../resource"


export const getTaxDatById = createAsyncThunk(
  "taxData/getById",
  async (id) => {
    const response = await api.get(`api/taxdata/${id}`)
    return {
      data: response.data
    }
  }
)

export const getBusinessNamesByOwner = createAsyncThunk(
  "taxData/getByOwner",
  async ({ ownerType, ownerId, params = {} }) => {
    const resource = getBusinessNameResource(ownerType)
    const response = await api.get(resource.list(ownerId), { params })
    return {
      data: response.data,
      params
    }
  }
)

export const createBusinessName = createAsyncThunk(
  "taxData/create",
  async ({ ownerType, ownerId, data }) => {
    const resource = getBusinessNameResource(ownerType)
    const response = await api.post(resource.collection, {
      ...data,
      ...getOwnerPayload(ownerType, ownerId)
    })
    return response.data
  }
)

export const updateBusinessName = createAsyncThunk(
  "taxData/update",
  async ({ ownerType, ownerId, id, data }) => {
    const resource = getBusinessNameResource(ownerType)
    const response = await api.put(`${resource.collection}/${id}`, {
      ...data,
      ...getOwnerPayload(ownerType, ownerId)
    })
    return response.data
  }
)

export const deleteBusinessNameByOwner = createAsyncThunk(
  "taxData/deleteByOwner",
  async ({ ownerType, ownerId, id, url }, { dispatch }) => {
    const resource = getBusinessNameResource(ownerType)
    const response = await api.delete(`${resource.collection}/${id}`)
    if (response.data.status === "success") {
      if (ownerId) {
        dispatch(getBusinessNamesByOwner({ ownerType, ownerId }))
      }
      dispatch(showModalSuccess({
        message: response.data.message,
        ...(url ? { url } : {})
      }))
    }
    return response.data
  }
)

export const transferTaxData = createAsyncThunk('taxData/transfer', async ({params, toggle}, {dispatch}) => {
  const response = await api.post(`api/taxdata/fransfer`, params)
  if (response.data.status === 'success') {
    toggle() // hide previous modal
    dispatch(showModalSuccess({message: response.data.message, url: '/users/clients'})) // show success modal
  }
})

export const taxDataSlice = createSlice({
  name: "clients",
  initialState: {
    data: null,
    ownerData: {
      data: [],
      meta: { current_page: 1, last_page: 1, total: 0 }
    },
    ownerSuggestions: [],
    ownerParams: {},
    total: 0,
    defaultValues: null,
    transfer_status: 'idle'
  },
  reducers: {
    resetTaxData: (state) => {
      state.data = null
      state.ownerData = {
        data: [],
        meta: { current_page: 1, last_page: 1, total: 0 }
      }
      state.ownerSuggestions = []
      state.ownerParams = {}
      state.total = 0
      state.defaultValues = null
      state.transfer_status = 'idle'
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getTaxDatById.fulfilled, (state, action) => {
      state.data = action.payload.data.data[0]
      const payload = action.payload.data.data[0]
      state.defaultValues = {
        procedencia: payload.origin,
        billing_type: payload.type,
        razon_social: payload.business_name,
        nombres: payload.names,
        primer_apellido: payload.last_name,
        segundo_apellido: payload.last_name_2,
        pais: payload.country.value,
        estado: payload.state.value,
        ciudad: payload.city,
        codigo_postal: payload.postal_code,
        colonia: payload.suburb,
        calle_numero: payload.address,
        tax_id: payload.taxid,
        rfc: payload.taxid,
        // cuota_base: "27%", // TODO move this value to config file
        billing: payload.billing_type,
        periodo_corte: payload.billing_period,
        dia: payload.billing_day,
        uso_cfdi: payload.uso_cfdi.value,
        client_id: payload.client_id
      }
    })
    builder.addCase(getBusinessNamesByOwner.fulfilled, (state, action) => {
      state.ownerData = normalizeTaxDataCollection(action.payload.data)
      state.ownerSuggestions = state.ownerData.data.map((item) => ({
        suggestion:
          item.business_name ??
          [item.names, item.last_name, item.last_name_2].filter(Boolean).join(" ")
      }))
      state.ownerParams = action.payload.params
    })
    builder.addCase(transferTaxData.pending, (state) => {
      state.transfer_status = 'loading'
    })
    builder.addCase(transferTaxData.fulfilled, (state) => {
      state.transfer_status = 'success'
    })
    builder.addCase(transferTaxData.rejected, (state) => {
      state.transfer_status = 'error'
    })
  }
})

export const { resetTaxData } = taxDataSlice.actions
export default taxDataSlice.reducer
